import {Observable} from 'rxjs/Observable';
import 'rxjs/add/observable/from';
import Connector from './connector';
import invariant from 'invariant';
import {createStore, applyMiddleware, compose, combineReducers} from 'redux';

import assign from 'lodash/assign';
import curry from 'lodash/curry';
import isArray from 'lodash/isArray';
import isFunction from 'lodash/isFunction';
import map from 'lodash/map';
import LogRocket from "logrocket";

const typeIs = curry((type, val) => typeof val === type);
const isObject = typeIs('object');
const isString = typeIs('string');

export default function ngReduxProvider() {
  let _reducer = undefined;
  let _middlewares = undefined;
  let _storeEnhancers = undefined;
  let _initialState = undefined;
  let _reducerIsObject = undefined;

  this.createStoreWith = (reducer, middlewares, storeEnhancers, initialState) => {
    invariant(
      isFunction(reducer) || isObject(reducer),
      'The reducer parameter passed to createStoreWith must be a Function or an Object. Instead received %s.',
      typeof reducer
    );

    invariant(
      !storeEnhancers || isArray(storeEnhancers),
      'The storeEnhancers parameter passed to createStoreWith must be an Array. Instead received %s.',
      typeof storeEnhancers
    );

    _reducer = reducer;
    _reducerIsObject = isObject(reducer);
    _storeEnhancers = storeEnhancers
    _middlewares = middlewares || [];
    _initialState = initialState;
  };

  this.$get = ($injector) => {
    const resolveMiddleware = middleware => isString(middleware)
      ? $injector.get(middleware)
      : middleware;

    const resolvedMiddleware = map(_middlewares, resolveMiddleware);

    const resolveStoreEnhancer = storeEnhancer => isString(storeEnhancer)
      ? $injector.get(storeEnhancer)
      : storeEnhancer;

    const resolvedStoreEnhancer = map(_storeEnhancers, resolveStoreEnhancer);

    if(_reducerIsObject) {
      const getReducerKey = key => isString(_reducer[key])
        ? $injector.get(_reducer[key])
        : _reducer[key];

      const resolveReducerKey = (result, key) => assign({}, result,
        { [key]: getReducerKey(key) }
      );

      const reducersObj = Object
        .keys(_reducer)
        .reduce(resolveReducerKey, {});

      _reducer = combineReducers(reducersObj);
    }

    const finalCreateStore = resolvedStoreEnhancer ? compose(...resolvedStoreEnhancer)(createStore) : createStore;

    let store;

    try {
      store = _initialState
        ? applyMiddleware(...resolvedMiddleware, LogRocket.reduxMiddleware())(finalCreateStore)(_reducer, _initialState)
        : applyMiddleware(...resolvedMiddleware, LogRocket.reduxMiddleware())(finalCreateStore)(_reducer);
    } catch (e) {
      store = _initialState
        ? applyMiddleware(...resolvedMiddleware)(finalCreateStore)(_reducer, _initialState)
        : applyMiddleware(...resolvedMiddleware)(finalCreateStore)(_reducer);
    }

    return {
      ...store,
      state$: Observable.from(store),
      connect: Connector(store)
    };
  };

  this.$get.$inject = ['$injector'];
}

/**
 * @typedef {Store} NgStore
 * @property {Observable<T>} state$
 * @property connect
 * @template T
 */



// WEBPACK FOOTER //
// ./src/js/_libs/ng-redux/components/ngRedux.js